exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width:768px){[data-v-58e4d522] .ant-table-body{scrollbar-width:none;-ms-overflow-style:none}[data-v-58e4d522] .ant-table-body::-webkit-scrollbar{width:0;height:0}}", ""]);

// exports
